import { TeamBasic, TeamFrontData } from '../Api/Teams/team.types'
import { SelectTeamData } from '../Api/Teams/team.types'
import { MAIN_PLL_URL, Team_LOGO_URL } from '../Config/config'
import { PackedMap, statFields } from './statsProcess'

export const champSeriesTeams: { [key: number]: string[] } = {
  2023: ['arc', 'atl', 'whp', 'chr'],
  2024: ['arc', 'can', 'red', 'wat'],
  2025: ['arc', 'can', 'whp', 'atl'],
}

export const websiteUrls = {
  shopBaseUrl: `https://shop.${MAIN_PLL_URL}`,
  statsBaseUrl: `https://stats.${MAIN_PLL_URL}`,
  ticketsBaseUrl: `https://${MAIN_PLL_URL}/schedule`,
  mediaPage: `https://${MAIN_PLL_URL}/media`,
  fullTeamStats: `https://stats.${MAIN_PLL_URL}/teams`,
  teamBannerUrl: `https://${MAIN_PLL_URL}/wp-content/uploads/2021/01`,
  baseAssetUrl: `https://${MAIN_PLL_URL}/wp-content/uploads/2021`,
  schedule: `https://${MAIN_PLL_URL}/schedule`,
  twitterUrl: 'https://twitter.com/',
  instagramUrl: 'https://instagram.com/',
}

export const teamDropdown = [
  { label: 'All Teams', value: 'All Teams' },
  { label: 'Archers', value: 'ARC' },
  { label: 'Atlas', value: 'ATL' },
  { label: 'Cannons', value: 'CAN' },
  { label: 'Chaos', value: 'CHA' },
  { label: 'Outlaws', value: 'OUT' },
  { label: 'Redwoods', value: 'RED' },
  { label: 'Waterdogs', value: 'WAT' },
  { label: 'Whipsnakes', value: 'WHP' },
  { label: 'Chrome', value: 'CHR' },
]

export const teamTransactionsDropdown = [
  { label: 'All Teams', value: 'All Teams' },
  { label: 'Archers', value: 'Archers' },
  { label: 'Atlas', value: 'Atlas' },
  { label: 'Cannons', value: 'Cannons' },
  { label: 'Chaos', value: 'Chaos' },
  { label: 'Outlaws', value: 'Outlaws' },
  { label: 'Redwoods', value: 'Redwoods' },
  { label: 'Waterdogs', value: 'Waterdogs' },
  { label: 'Whipsnakes', value: 'Whipsnakes' },
  { label: 'Chrome', value: 'Chrome' },
]

export const TEAM_LOGO_IMAGES: { [key: string]: string } = {
  archers: `${Team_LOGO_URL}/2024/Logo/2024_archers_primary_color.png`,
  atlas: `${Team_LOGO_URL}/2024/Logo/2024_atlas_primary_color.png`,
  cannons: `${Team_LOGO_URL}/2024/Logo/2024_cannons_primary_color.png`,
  chaos: `${Team_LOGO_URL}/2024/Logo/2024_chaos_primary_color.png`,
  outlaws: `${Team_LOGO_URL}/2024/Logo/2024_outlaws_primary_color.png`,
  redwoods: `${Team_LOGO_URL}/2024/Logo/2024_redwoods_primary_color.png`,
  waterdogs: `${Team_LOGO_URL}/2024/Logo/2024_waterdogs_primary_color.png`,
  whipsnakes: `${Team_LOGO_URL}/2024/Logo/2024_whipsnakes_primary_color.png`,
  chrome: `https://${MAIN_PLL_URL}/chrome_primary_fullcolor`,
  baptiste: `${Team_LOGO_URL}/2022/Logo/team-baptiste.png`,
  farrell: `${Team_LOGO_URL}/2022/Logo/team-farrell.png`,
  adversaries: `${Team_LOGO_URL}/2021/07/adversaries.jpg`,
  defenders: `${Team_LOGO_URL}/2021/07/defenders.jpg`,
  veterans: `${Team_LOGO_URL}/2023/Logo/2023_ASG_veterans.webp`,
  'rising stars': `${Team_LOGO_URL}/2023/Logo/2023_ASG_rising stars.webp`,
  'player pool': `https://${MAIN_PLL_URL}/wp-content/uploads/2024/03/shield-bg.png`,
  'east': `https://${MAIN_PLL_URL}/wp-content/uploads/2024/06/24ASG_EIcon_FullColor.webp`,
  'west': `https://${MAIN_PLL_URL}/wp-content/uploads/2024/06/24ASG_WIcon_FullColor.webp`,
  'charm': `${Team_LOGO_URL}/2024/Logo/wll_maryland_charm_logo_primary.png`,
  'palms': `${Team_LOGO_URL}/2024/Logo/wll_california_palms_logo_primary.png`,
  'charging': `${Team_LOGO_URL}/2024/Logo/wll_new_york_charging_logo_primary.png`,
  'guard': `${Team_LOGO_URL}/2024/Logo/wll_boston_guard_logo_primary.png`,
}

export const teamsBasicArray: TeamBasic[] = [
  {
    officialId: 'ARC',
    fullName: 'Archers',
    location: 'Utah',
    locationCode: 'UTA',
    rectLogo: '',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_archers_primary_color.png`,
    logo2: `${Team_LOGO_URL}/2024/Logo/2024_archers_primary_gray.png`,
    sortOrder: 8,
    primaryColor: '#FF5216',
    secondaryColor: '#002244',
  },
  {
    officialId: 'ATL',
    fullName: 'Atlas',
    location: 'New York',
    locationCode: 'NYA',
    rectLogo: '',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_atlas_primary_color.png`,
    logo2: `${Team_LOGO_URL}/2024/Logo/2024_atlas_primary_gray.png`,
    sortOrder: 6,
    primaryColor: '#00B1FF',
    secondaryColor: '#011E41',
  },
  {
    officialId: 'CAN',
    fullName: 'Cannons',
    location: 'Boston',
    locationCode: 'BOS',
    rectLogo: '',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_cannons_primary_color.png`,
    logo2: `${Team_LOGO_URL}/2024/Logo/2024_cannons_primary_gray.png`,
    sortOrder: 1,
    primaryColor: '#B0B6BB',
    secondaryColor: '#C52032',
  },
  {
    officialId: 'CHA',
    fullName: 'Chaos',
    location: 'Carolina',
    locationCode: 'CAR',
    rectLogo: '',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_chaos_primary_color.png`,
    logo2: `${Team_LOGO_URL}/2024/Logo/2024_chaos_primary_gray.png`,
    sortOrder: 3,
    primaryColor: '#FF0E11',
    secondaryColor: '#000',
  },
  {
    officialId: 'OUT',
    location: 'Denver',
    locationCode: 'DEN',
    rectLogo: '',
    fullName: 'Outlaws',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_outlaws_primary_color.png`,
    logo2: `${Team_LOGO_URL}/2024/Logo/2024_outlaws_primary_gray.png`,
    sortOrder: 4,
    primaryColor: '#FF5216',
    secondaryColor: '#2E2E4D',
  },
  {
    officialId: 'RED',
    fullName: 'Redwoods',
    location: 'California',
    locationCode: 'CAL',
    rectLogo: '',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_redwoods_primary_color.png`,
    logo2: `${Team_LOGO_URL}/2024/Logo/2024_redwoods_primary_gray.png`,
    sortOrder: 2,
    primaryColor: '#004B37',
    secondaryColor: '#FFD200',
  },
  {
    officialId: 'WAT',
    fullName: 'Waterdogs',
    location: 'Philadelphia',
    locationCode: 'PHI',
    rectLogo: '',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_waterdogs_primary_color.png`,
    logo2: `${Team_LOGO_URL}/2024/Logo/2024_waterdogs_primary_gray.png`,
    sortOrder: 7,
    primaryColor: '#6C20C4',
    secondaryColor: '#99A4AD',
  },
  {
    officialId: 'WHP',
    fullName: 'Whipsnakes',
    location: 'Maryland',
    locationCode: 'MDW',
    rectLogo: '',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_whipsnakes_primary_color.png`,
    logo2: `${Team_LOGO_URL}/2024/Logo/2024_whipsnakes_primary_gray.png`,
    sortOrder: 5,
    primaryColor: '#FF0000',
    secondaryColor: '#FFCE00',
  },
]

export const selectTeamDataArr: SelectTeamData[] = [
  {
    officialId: 'ARC',
    fullName: 'Archers',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_archers_primary_color.png`,
    location: 'Utah',
    locationCode: 'UTA',
    primaryColor: '#FF5216',
    secondaryColor: '#002244',
    joinText:
      'Join the fan community and be the first to receive updates on tickets, games, and much more',
    buttonText: 'Join',
    sortOrder: 1,
    link: `https://app.viralsweep.com/sweeps/full/44df20-146748?framed=1`,
    welcomeText: 'Welcome to the Archers',
  },
  {
    officialId: 'ATL',
    fullName: 'Atlas',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_atlas_primary_color.png`,
    location: 'New York',
    locationCode: 'NYA',
    primaryColor: '#00B1FF',
    secondaryColor: '#011E41',
    joinText:
      'Join the fan community and be the first to receive updates on tickets, games, and much more',
    buttonText: 'Join',
    sortOrder: 1,
    link: `https://app.viralsweep.com/sweeps/full/9b4c08-146751?framed=1`,
    welcomeText: 'Welcome to the Atlas family',
  },
  {
    officialId: 'CAN',
    fullName: 'Cannons',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_cannons_primary_color.png`,
    location: 'Boston',
    locationCode: 'BOS',
    primaryColor: '#B0B6BB',
    secondaryColor: '#C52032',
    joinText:
      'Join the Boom Squad and be the first to receive updates on tickets, games, and much more',
    buttonText: 'Join',
    sortOrder: 1,
    link: `https://app.viralsweep.com/sweeps/full/923dfc-146752?framed=1`,
    welcomeText: 'Welcome to the Boom Squad',
  },
  {
    officialId: 'CHA',
    fullName: 'Chaos',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_chaos_primary_color.png`,
    location: 'Carolina',
    locationCode: 'CAR',
    primaryColor: '#FF0E11',
    secondaryColor: '#000',
    joinText:
      'Join the fan community and be the first to receive updates on tickets, games, and much more',
    buttonText: 'Join',
    sortOrder: 1,
    link: `https://app.viralsweep.com/sweeps/full/e49f17-146754?framed=1`,
    welcomeText: 'Welcome to the Chaos',
  },
  {
    officialId: 'OUT',
    fullName: 'Outlaws',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_outlaws_primary_color.png`,
    location: 'Denver',
    locationCode: 'DEN',
    primaryColor: '#FF5216',
    secondaryColor: '#2E2E4D',
    joinText:
      'Join the fan community and be the first to receive updates on tickets, games, and much more',
    buttonText: 'Join',
    sortOrder: 1,
    link: `https://app.viralsweep.com/sweeps/full/8dc62d-146756?framed=1`,
    welcomeText: 'Welcome to the Outlaws',
  },
  {
    officialId: 'RED',
    fullName: 'Redwoods',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_redwoods_primary_color.png`,
    location: 'California',
    locationCode: 'CAL',
    primaryColor: '#004B37',
    secondaryColor: '#FFD200',
    joinText:
      'Join Woods Nation and be the first to receive updates on tickets, games, and much more',
    buttonText: 'Join',
    sortOrder: 1,
    link: `https://app.viralsweep.com/sweeps/full/6ff494-146757?framed=1`,
    welcomeText: 'Welcome to the Woods',
  },
  {
    officialId: 'WAT',
    fullName: 'Waterdogs',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_waterdogs_primary_color.png`,
    location: 'Philadelphia',
    locationCode: 'PHI',
    primaryColor: '#6C20C4',
    secondaryColor: '#99A4AD',
    joinText:
      'Join The Pack and be the first to receive updates on tickets, games, and much more',
    buttonText: 'Join',
    sortOrder: 1,
    link: `https://app.viralsweep.com/sweeps/full/ab504b-146758?framed=1`,
    welcomeText: 'Welcome to The Pack',
  },
  {
    officialId: 'WHP',
    fullName: 'Whipsnakes',
    logo1: `${Team_LOGO_URL}/2024/Logo/2024_whipsnakes_primary_color.png`,
    location: 'Maryland',
    locationCode: 'MDW',
    primaryColor: '#FF0000',
    secondaryColor: '#FFCE00',
    joinText:
      'Join Whips Nation and be the first to receive updates on tickets, games, and much more',
    buttonText: 'Join',
    sortOrder: 1,
    link: `https://app.viralsweep.com/sweeps/full/7bc919-146759?framed=1`,
    welcomeText: 'Welcome to Whips Nation',
  },
]

export const teamsDataArray: TeamFrontData[] = [
  {
    officialId: 'ARC',
    fullName: 'Archers',
    teamColor: '#FF5216',
    background: '#23427A',
    igTag: 'utaharchers',
    twTag: 'PLLArchers',
    teamBanner: `https://${MAIN_PLL_URL}/wp-content/uploads/2023/11/tt3-arc-team-banner.webp`,
    teamLogo: '2024_archers_primary_color.png',
    logoSecondary: `${Team_LOGO_URL}/2024/Logo/2024_archers_primary_color.png`,
    shopImg: '/02/archersMerch@2x.png',
  },
  {
    officialId: 'ATL',
    fullName: 'Atlas',
    teamColor: '#00B1FF',
    background: '#3BA9F6',
    igTag: 'nyatlas',
    twTag: 'PLLAtlas',
    teamBanner: `https://${MAIN_PLL_URL}/wp-content/uploads/2023/11/tt3-atl-team-banner.webp`,
    teamLogo: '2024_atlas_primary_color.png',
    logoSecondary: `${Team_LOGO_URL}/2024/Logo/2024_atlas_primary_color.png`,
    shopImg: '/02/atlasMerch@2x.png',
    twitter: 'pllatlas',
    instagram: 'pllatlas',
  },
  {
    officialId: 'CAN',
    fullName: 'Cannons',
    teamColor: '#B0B6BB',
    background: '#002244',
    igTag: 'bostoncannons',
    twTag: 'PLLCannons',
    teamBanner: `https://${MAIN_PLL_URL}/wp-content/uploads/2023/11/tt3-can-team-banner.webp`,
    teamLogo: '2024_cannons_primary_color.png',
    logoSecondary: `${Team_LOGO_URL}/2024/Logo/2024_cannons_primary_color.png`,
    shopImg: '/02/cannonsMerch@2x.png',
  },
  {
    officialId: 'CHA',
    fullName: 'Chaos',
    teamColor: '#FF0E11',
    background: '#EF484B',
    igTag: 'chaoslc',
    twTag: 'PLLChaos',
    teamBanner: `https://${MAIN_PLL_URL}/wp-content/uploads/2023/11/tt3-cha-team-banner.webp`,
    teamLogo: '2024_chaos_primary_color.png',
    logoSecondary: `${Team_LOGO_URL}/2024/Logo/2024_chaos_primary_color.png`,
    shopImg: '/02/chaosMerch@2x.png',
    spotifyId: '5KoC5q0cOyJg9Hx2zxDBuF',
  },
  {
    officialId: 'CHR',
    fullName: 'Chrome',
    teamColor: '#ea5f9a',
    background: '#95D6DB',
    igTag: 'pllchrome',
    twTag: 'PLLChrome',
    teamBanner: `https://${MAIN_PLL_URL}/chromebanner`,
    teamLogo: 'chromeLogoBlock@2x.png',
    logoSecondary: `https://${MAIN_PLL_URL}/wp-content/uploads/2021/01/chromeLogoBlock@2x.png`,
    shopImg: '/02/chromeMerch@2x.png',
  },
  {
    officialId: 'OUT',
    fullName: 'Outlaws',
    teamColor: '#000000',
    background: '#95D6DB',
    igTag: 'denveroutlaws',
    twTag: 'DenverOutlaws',
    teamBanner: `https://${MAIN_PLL_URL}/wp-content/uploads/2023/11/tt3-out-team-banner.webp`,
    teamLogo: '2024_outlaws_primary_color.png',
    logoSecondary: `${Team_LOGO_URL}/2024/Logo/2024_outlaws_primary_color.png`,
    shopImg: '',
  },
  {
    officialId: 'RED',
    fullName: 'Redwoods',
    teamColor: '#004B37',
    background: '#006F55',
    igTag: 'redwoodslc',
    twTag: 'PLLRedwoods',
    teamBanner: `https://${MAIN_PLL_URL}/wp-content/uploads/2023/11/tt3-red-team-banner.webp`,
    teamLogo: '2024_redwoods_primary_color.png',
    logoSecondary: `${Team_LOGO_URL}/2024/Logo/2024_redwoods_primary_color.png`,
    shopImg: '/02/redwoodsMerch@2x.png',
  },
  {
    officialId: 'WAT',
    fullName: 'Waterdogs',
    teamColor: '#6C20C4',
    background: '#000000',
    igTag: 'phillywaterdogs',
    twTag: 'PLLWaterdogs',
    teamBanner: `https://${MAIN_PLL_URL}/wp-content/uploads/2023/11/tt3-wat-team-banner.webp`,
    teamLogo: 'waterdogsLogoBlock@2x.png',
    logoSecondary: `${Team_LOGO_URL}/2024/Logo/2024_waterdogs_primary_color.png`,
    shopImg: '/02/waterdogs@2x.png',
    spotifyId: '6LkPLJFw7oGplZeYTK0Pzx',
  },
  {
    officialId: 'WHP',
    fullName: 'Whipsnakes',
    teamColor: '#FFCE00',
    background: '#E71C3F',
    igTag: 'MarylandWhips',
    twTag: 'PLLWhipsnakes',
    teamBanner: `https://${MAIN_PLL_URL}/wp-content/uploads/2023/11/tt3-whp-team-banner.webp`,
    teamLogo: 'whipsnakesLogoBlock@2x.png',
    logoSecondary: `${Team_LOGO_URL}/2024/Logo/2024_whipsnakes_primary_color.png`,
    shopImg: '/02/whipsnakes@2x.png',
    spotifyId: '2z3026xjxd9qFkbCad4nur',
  },
  {
    officialId: 'ZPP',
    fullName: 'Player Pool',
    teamColor: '#000',
    background: '#eeeeee',
    igTag: 'pll',
    twTag: 'PremierLacrosse',
    teamBanner: '',
    teamLogo: '',
    shopImg: '',
  },
  {
    officialId: 'ASH',
    fullName: 'Veterans',
    teamColor: '#FFCB06',
    background: '#FFCB06',
    igTag: 'pll',
    twTag: 'PremierLacrosse',
    teamBanner: '',
    teamLogo: '',
    shopImg: '',
  },
  {
    officialId: 'ASA',
    fullName: 'Rising Stars',
    teamColor: '#000000',
    background: '#000000',
    igTag: 'pll',
    twTag: 'PremierLacrosse',
    teamBanner: '',
    teamLogo: '',
    shopImg: '',
  },
  // WLL TEAMS //
  {
    officialId: 'WCHA',
    fullName: 'Charging',
    teamColor: '#000000',
    background: '#000000',
    igTag: '',
    twTag: '',
    teamBanner: '',
    teamLogo: 'https://img.premierlacrosseleague.com/Teams/2024/Logo/wll_new_york_charging_logo.png',
    shopImg: '',
  },
  {
    officialId: 'WGUA',
    fullName: 'Guard',
    teamColor: '#000000',
    background: '#000000',
    igTag: '',
    twTag: '',
    teamBanner: '',
    teamLogo: 'https://img.premierlacrosseleague.com/Teams/2024/Logo/wll_boston_guard_logo.png',
    shopImg: '',
  },
  {
    officialId: 'WCHR',
    fullName: 'Charm',
    teamColor: '#000000',
    background: '#000000',
    igTag: '',
    twTag: '',
    teamBanner: '',
    teamLogo: 'https://img.premierlacrosseleague.com/Teams/2024/Logo/wll_maryland_charm_logo.png',
    shopImg: '',
  },
  {
    officialId: 'WPLM',
    fullName: 'Palms',
    teamColor: '#000000',
    background: '#000000',
    igTag: '',
    twTag: '',
    teamBanner: '',
    teamLogo: 'https://img.premierlacrosseleague.com/Teams/2024/Logo/wll_california_palms_logo.png',
    shopImg: '',
  }
]

export const pllDefaultTeam = {
  officialId: 'PLL',
  fullName: 'Premier Lacrosse League',
  teamColor: '#ffcb06',
  background: '#eeeeee',
  igTag: 'pll',
  twTag: 'PremierLacrosse',
  teamBanner: '',
  teamLogo: '',
  shopImg: '',
}
export const teamStatFields: PackedMap = {
  ...statFields,
  's': ['s', 'Scores', 'scores'],
  'sPG': ['sPG', 'Scores Per Game', 'scoresPG'],
  'shPG': ['shPG', 'Shots Per Game', 'shotsPG'],
}

export const fullNameTeamStatLabels = Object.fromEntries(
  Object.values(teamStatFields).map(([_, fullLabel, key]) => [key, fullLabel])
)
